// src/services/authService.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL_ADMIN;

export const loginUser = async (credentials) => {
  const response = await axios.post(`${API_BASE}/auth/login`, {
    email: credentials.email,
    password: credentials.password,
  });
  return response.data;
};
